<template>
  <modal closeMutation="SET_ITEM_CANCEL_SUBSCRIPTION_MODAL" class="modal_cancel_subscription">
    <div>
      <p class="cancel_subscription_title">Вы действительно хотите отменить подписку?</p>
      <p class="cancel_subscription_body">Действие подписки будет прекращено {{ formattedEndDate }}</p>
      <div class="modal_buttons row">
        <div class="button_cancel col-5" @click="closeModal"><p>Нет</p></div>
        <div class="button_separator col-2">|</div>
        <div class="button_accept col-5" @click="cancelSubscription"><p>Да</p></div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@/views/Modal.vue";
import moment from "moment/moment";
import { useToast } from "vue-toastification";

export default {
  name: "ItemModalCancelSubscription",
  components: {Modal},
  props: {
    item: {},
  },
  setup() {
    const toast = useToast();
    return { toast }
  },
  computed: {
    formattedEndDate() {
      if (this.item.end_date === null) {
        return null;
      }
      return moment(this.item.end_date, 'YYYY-MM-DD').format('DD.MM.YYYY');
    }
  },
  methods: {
    closeModal() {
      this.$store.commit('SET_ITEM_CANCEL_SUBSCRIPTION_MODAL', false);
    },
    async cancelSubscription() {
      try {
        this.$store.commit('SHOW_MODAL_PRELOADER');
        const result = await this.$api.contract.cancelSubscription(this.item.id);
        this.$store.commit('HIDE_MODAL_PRELOADER');
        const success = result.data && result.data.success;
        if (success) {
          let successMessage = 'Подписка «' + this.item.name + '» успешно отменена';
          this.$store.commit('SHOW_SUCCESS_MODAL', successMessage);
          this.closeModal();
        } else {
          this.$store.commit('SET_ITEM_CANCEL_SUBSCRIPTION_MODAL', false);
          this.toast.error('Произошла ошибка. Пожалуйста, попробуйте позже');
        }
      } catch (error) {
        this.$store.commit('HIDE_MODAL_PRELOADER');
        this.$store.commit('SET_ITEM_CANCEL_SUBSCRIPTION_MODAL', false);
        this.toast.error('Произошла ошибка. Пожалуйста, попробуйте позже');
      }
    },
  },
};
</script>
